import { Box } from '@chakra-ui/react';
import React from 'react';

interface PaddingProps {
  children: React.ReactNode;
  backgroundColor?: string;
  verticalPadding?: number;
}

const Padding = ({
  children,
  backgroundColor,
  verticalPadding,
}: PaddingProps): React.JSX.Element => {
  return (
    <Box backgroundColor={backgroundColor} paddingY={verticalPadding}>
      <Box className="mx-auto max-w-[90vw] lg:max-w-[85vw] xl:max-w-[1100px]">{children}</Box>
    </Box>
  );
};

export default Padding;
